import {
  Dialog,
  DialogTitle,
  DialogContent,
  Button,
  Typography,
  Stack,
  Box,
} from "@mui/material";
import React from "react";

interface FormModalProps {
  open: boolean;
  onClose: () => void;
  onSubmit?: (e: React.FormEvent<HTMLFormElement>) => void;
  title: string;
  description?: string;
  children?: React.ReactNode;
  submitLabel?: string;
  isSubmitDisabled?: boolean;
  emptyMessage?: string;
}

export const FormModal: React.FC<FormModalProps> = ({
  open,
  onClose,
  onSubmit,
  title,
  description,
  children,
  submitLabel = "Salvar",
  isSubmitDisabled = false,
  emptyMessage,
}) => {
  const hasFormContent = !!children && !emptyMessage;

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        <Typography variant="h6" fontWeight="bold">
          {title}
        </Typography>
        {description && (
          <Typography variant="body2" color="text.secondary">
            {description}
          </Typography>
        )}
      </DialogTitle>

      <DialogContent>
        {hasFormContent ? (
          <Box component="form" onSubmit={onSubmit} mt={1}>
            {children}
            <Stack direction="row" justifyContent="flex-end" spacing={2} mt={4}>
              <Button variant="outlined" onClick={onClose}>
                Cancelar
              </Button>
              <Button type="submit" variant="contained" disabled={isSubmitDisabled}>
                {submitLabel}
              </Button>
            </Stack>
          </Box>
        ) : (
          <Stack spacing={2} alignItems="center" py={3}>
            <Typography variant="body1" color="text.secondary" textAlign="center">
              {emptyMessage || "Nada disponível no momento."}
            </Typography>
            <Button variant="contained" onClick={onClose}>
              Voltar
            </Button>
          </Stack>
        )}
      </DialogContent>
    </Dialog>
  );
};
